import Vue from 'vue';
import App from './App.vue';
import Router from './Router';
import './assets/scss/bulma-extend.scss';
import {
	Store
} from './Store';
import {
	beforeEachRoute
} from './middleware/AuthMiddleware';
import {
	EmojiPickerPlugin
} from 'vue-emoji-picker';
import {
	dynamicTitle
} from './plugins/VueDynamicTitle'
import {
	library
} from '@fortawesome/fontawesome-svg-core';
import {
	faAngleDown,
	faAngleRight,
	faBookOpen,
	faClock,
	faClipboardCheck,
	faFolder,
	faFolderOpen,
	faFilePdf,
	faFileWord,
	faFilePowerpoint,
	faFileCsv,
	faFileImage,
	faFileArchive,
	faFileAudio,
	faFileVideo,
	faFile,
	faPlusSquare,
	faMinusCircle,
	faEdit,
	faArrowsAlt,
	faBell,
	faSearch,
	faCalendarAlt,
	faUserCircle,
	faEllipsisV,
	faExpandArrowsAlt,
	faUsers,
	faLink,
	faAlignJustify


} from '@fortawesome/free-solid-svg-icons';
import {
	faWhatsapp,
	faSkype
} from '@fortawesome/free-brands-svg-icons'
import axios from 'axios'
import moment from 'moment-timezone'

import {
	FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';

// import VueTippy from 'vue-tippy';
// import vmodal from 'vue-js-modal';
import VueUpload from "./plugins/VueUpload.js";
import ChatFileLoader from './components/chat/ChatFileLoader';
import VueUploadComponent from './components/Vue-Upload';
import VueSweetalert2 from 'vue-sweetalert2';

// Vue.use(vmodal);
// Vue.use(VueTippy);
Vue.use(VueUpload);
Vue.use(VueSweetalert2);
// import AudioRecorder from 'vue-audio-recorder';
// import tippy from 'tippy.js';
// Object.defineProperty(Vue.prototype, '$tippy', { value: tippy });
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

// Vue.use(AudioRecorder);


library.add(faAngleDown,
	faAngleRight,
	faBookOpen,
	faClock,
	faWhatsapp,
	faClipboardCheck,
	faFolder,
	faFolderOpen,
	faFilePdf,
	faFileWord,
	faFilePowerpoint,
	faFileCsv,
	faFileImage,
	faFileArchive,
	faFileAudio,
	faFileVideo,
	faFile,
	faPlusSquare,
	faMinusCircle,
	faEdit, faArrowsAlt, faBell, faSearch,
	faSkype, faCalendarAlt, faBell, faUserCircle, faEllipsisV, faExpandArrowsAlt, faUsers, faLink, faAlignJustify


);




import {
	ACCESS_TOKEN,
	SOCKET_AUTH_URL,
	SOCKET_KEY
} from './Variables'
import Echo from 'laravel-echo'
window.Pusher = require('pusher-js');

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: SOCKET_KEY,
	cluster: "ams3",
	encrypted: true,
	httpHost: 'sockets.codespace.co.za',
	wsHost: 'sockets.codespace.co.za',

	auth: {
		headers: {
			Authorization: "Bearer " + ACCESS_TOKEN
		}
	},
	authEndpoint: SOCKET_AUTH_URL
});



Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ChatFileLoader', ChatFileLoader);
Vue.component('UploadComponent', VueUploadComponent);
Vue.use(EmojiPickerPlugin);

Vue.config.productionTip = false;

new Vue({
	router: Router,
	store: Store,
	mounted() {
		Store.dispatch('loader/show', 'Welcome back....');
		Store.dispatch('auth/getUser', {
			success: state => {
				state.requestedHandshake = true;
				Store.dispatch('loader/hide');
				this.$store.dispatch('notifications/init', {
					onOpen: (socket) => {
						// Register user's socket connection
						this.$store.dispatch('notifications/registerConnection', {
							resourceId: 'resource' + state.user.id,
							socket: socket
						});
					},

					onMessage: (s, message) => {
						message = message.data;
						if (message != 'message') {
							message = JSON.parse(message);
							if (message.messageType != undefined) {
								this.$store.dispatch('notifications/push', message);
							}
						}

					}
				});
			},
			error: state => {
				state.requestedHandshake = true;
				Store.dispatch('loader/hide');
			},
		});
	},
	render: h => h(App),
}).$mount('#app');